import React, { FC, PropsWithChildren } from 'react'
import styles from './MainLayout.module.css'
import Header from '../blocks/Header/Header'

const MainLayout: FC<PropsWithChildren> = (props) => {
  return (
    <div className={styles.layout}>
      <Header />
      <div className={styles.content}>{props.children}</div>
    </div>
  )
}

export default MainLayout
